import styled from "@emotion/styled";
import { Container, Typography, Grid, Button } from "@mui/material";
import React from "react";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import WaitImg from "../../../assets/wait-img.png";
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

const WorkContainer = styled(Container)`
    background-image: linear-gradient(to right,#01014D ,#000024);
    padding-top:50px;
    padding-bottom: 50px;
`
const Heading = styled(Typography)`
    color:#fff;
    font-size:50px;
    font-family: poppins-b;
    text-align: left;
    margin-bottom: 30px;
    @media (max-width: 749px){
        font-size:30px;
        margin-bottom: 15px;
    }
`
const TabBtn = styled(Tab)`
    color:transparent;
    -webkit-text-stroke: 1px #fff;
    font-family: poppins-b;
    font-size:60px;
    text-align: left;
    max-width:unset;
    min-width:unset;
    max-height: unset;
    min-height: unset;
    align-items: unset;
    @media (max-width: 1024px) and (min-width: 601px){
        font-size: 30px;
    }
    @media (max-width: 600px){
        font-size:16px;
        padding-left:0px;
        padding-right:20px;
    }
`
const Desc = styled.p`
    font-size:15px;
    color:#fff;
    text-align: left;
    font-family: poppins-light;
    @media (max-width: 900px){
        font-size:13px;
    }
`
const TabImg = styled.img`
    width:100%;
    max-width:100%;
    height:auto;
`
const TabsGrid = styled(Grid)`display: flex;
    display: flex;
    align-items: center;
    @media(min-width: 600px){
        padding-top: 40px !important;
    }
`
const TabHeading = styled(Typography)`
    color: #fff;
    font-size:30px;
    font-family: poppins-b;
    text-align: left;
    @media (max-width: 900px){
        font-size:25px;
    }
`
const TabHeader = styled.div`
    display:flex;
    justify-content: space-between;
    align-items: center;
`
const SubHeading = styled.p`
    color:#00A9FF;
    font-family:poppins-light;
    font-size:15px;
    text-align:right;
`
const TabContent = styled.div`
    background-color:#01014D;
    border-radius:10px;
    padding:30px;
    display: grid;
    @media (max-width: 600px){
        padding:15px;   
    }
`
const ContentHeadings = styled.div`
    display:flex;
    border-bottom:1px solid #fff;
`
const FirstHeading = styled.p`
    color:#707070;
    font-family:poppins-b;
    font-size:18px;
    text-align:left;
    margin-right:25px;
    @media (max-width: 900px){
        font-size:13px;
    }
`
const SecondHeading = styled.p`
    color:#fff;
    font-family:poppins-b;
    font-size:18px;
    text-align:left;
    @media (max-width: 900px){
        font-size:13px;
    }
`
const Deposit = styled.p`
    color:#fff;
    font-family:poppins-b;
    font-size:18px;
    text-align:left;
    margin-right:25px;
    @media (max-width: 900px){
        font-size:13px;
    }
`
const Withdraw = styled.p`
    color:#707070;
    font-family:poppins-b;
    font-size:18px;
    text-align:left;
    @media (max-width: 900px){
        font-size:13px;
    }
`
const FieldLabel = styled.p`
    color:#fff;
    font-family:poppins-m;
    font-size:18px;
    text-align:left;
    margin-top:30px;
    @media (max-width: 900px){
        font-size:13px;
        margin-top:15px;    
    }
`
const TextFields = styled(TextField)`
    background-color: #010139;
    border:1px solid #010139 !important;
    border-radius:10px;
    input{
        color:#fff;
        font-family:poppins-light;
        font-size:15px;
        text-align:left;
        border:1px solid #010139 !important;
        @media (max-width: 900px){
            font-size:13px;
            padding:10px;
        }
    }
`
const Btn = styled(Button)`
    color:#000;
    background-color: #fff;
    border-radius: 10px;
    text-align: center;
    width:100%;
    margin-top:20px;
    padding:10px;
    font-family: poppins-b;
    text-transform: lowercase;
    @media (max-width: 900px){
        padding:5px;   
    }
`

const RadioBtn = styled(FormControlLabel)`
    color:#fff;
    font-family:poppins-m;
    font-size:18px;
    text-align:left;
    span{
        font-family:poppins-m;
        font-size:16px;
        @media (max-width: 900px){
            font-size:13px;
        }
    }
    svg{
        fill: #fff;
    }
    @media (max-width: 900px){
        font-size:13px;
        margin-top:15px;    
    }
`

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <div>{children}</div>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
      'aria-controls': `vertical-tabpanel-${index}`,
    };
  }
  
const HowItWorks = () => {
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
      };
    const [RadioValue, setRadioValue] = React.useState('300,000');

    const handleRadio = (e) => {
        setRadioValue(e.target.value);
      };
    
    return(
        <WorkContainer maxWidth="xxl" id="howitworks">
            <Container maxWidth="xl" sx={{padding:'0px'}}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                        <Heading data-aos="fade-right" variant="h1">How It Work</Heading>
                    </Grid>
                    <TabsGrid data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine" item xs={12} sm={5} md={5}>
                        <Tabs
                            orientation="vertical"
                            variant="scrollable"
                            value={value}
                            onChange={handleChange}
                            aria-label="Vertical tabs example"
                            sx={{ borderRight: 1, borderColor: 'divider' }}
                        >
                            <TabBtn label="Deposit" {...a11yProps(0)} />
                            <TabBtn label="Wait" {...a11yProps(1)} />
                            <TabBtn label="Withdraw" {...a11yProps(2)} />
                        </Tabs>
                        </TabsGrid>
                        <Grid data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine" item xs={12} sm={7} md={7}>
                        <TabPanel value={value} index={0}>
                            <TabHeader>
                                <TabHeading variant="h3">Mixer</TabHeading>
                                <SubHeading><span style={{color:"#fff"}}>(0)</span> Recent Transaction</SubHeading>
                            </TabHeader>
                            <TabContent>
                                <ContentHeadings>
                                    <Deposit>Deposit</Deposit>
                                    <Withdraw>Withdraw</Withdraw>
                                </ContentHeadings>
                                <FieldLabel>Please select amount that you would like to mix.</FieldLabel>
                                
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        value={RadioValue}
                                        onChange={handleRadio}
                                    >
                                        <RadioBtn value="300,000" control={<Radio />} label="300,000 PLS" />
                                        <RadioBtn value="500,000" control={<Radio />} label="500,000 PLS" />
                                        <RadioBtn value="1000,000" control={<Radio />} label="100,000 PLS" />
                                        <RadioBtn value="3000,000" control={<Radio />} label="300,000 PLS" />
                                    </RadioGroup>
                                    <Btn href="https://dapp.pulsemixer.org/">Continue</Btn>     
                                </FormControl>
                                
                            </TabContent>
                            <Desc>Users are charged a small 5% fee when using the mixer 
                                to send funds anonymously and securely.
                            </Desc>
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <div>
                                <div><TabImg src={WaitImg} /></div>
                                <Desc>Users are charged a small 5% fee when using the mixer
                                     to send funds anonymously and securely.
                                </Desc>
                            </div>
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <TabHeader>
                                <TabHeading variant="h3">Mixer</TabHeading>
                                <SubHeading><span style={{color:"#fff"}}>(0)</span> Recent Transaction</SubHeading>
                            </TabHeader>
                            <TabContent>
                                <ContentHeadings>
                                    <FirstHeading>Deposit</FirstHeading>
                                    <SecondHeading>Withdraw</SecondHeading>
                                </ContentHeadings>
                                <FieldLabel>Note</FieldLabel>
                                <TextFields fullWidth id="fullWidth" placeholder="Paste your deposit note here"/>
                                <FieldLabel>Recipient Address</FieldLabel>
                                <TextFields fullWidth id="fullWidth" placeholder="Paste recipient address here"/>   
                                <Btn href="https://dapp.pulsemixer.org/">Continue</Btn>   
                            </TabContent>
                            <Desc>Users are charged a small 5% fee when using the
                                 mixer to send funds anonymously and securely.
                            </Desc>
                        </TabPanel>
                    </Grid>
                </Grid>
            </Container>
        </WorkContainer>
    );
}

export default HowItWorks;